'use client';

import { useCallback } from 'react';

import { useData } from '@/components';
import { useCookies } from '@/hooks';
import { CookiesNames } from '@/constants';
import {
  isStoreAgeGateSatisfied,
  StoreTermsMap,
} from 'app/_components/AgeGate/utils';

/** Returns `needsStoreGate(slug)` — `true` when that store's gate exists and isn't accepted yet. */
export const useStoreAgeGate = () => {
  const { ageGate } = useData();
  const { getCookieObject } = useCookies();

  return useCallback(
    (storeSlug?: string | null): boolean => {
      const storeTerms = getCookieObject<StoreTermsMap>(
        CookiesNames._STORE_TERMS,
      );
      return !isStoreAgeGateSatisfied(ageGate?.data, storeSlug, storeTerms);
    },
    [ageGate, getCookieObject],
  );
};
